(ns manage.resource.adform-campaigns
  (:require [common.url-template :as url-tpl]
            [re-frame.core :as rf]))

(def campaigns-url (:api/adform-campaigns-url url-tpl/templates))

(rf/reg-event-fx :resource.adform-campaigns/get-campaigns-for-advertiser
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)
   (rf/inject-cofx :sub :context)]
  (fn [{:keys [db url-context context] :as cofx} [_ adserver-config-id search]]
    {:db (assoc-in db [:resource.adform-campaigns/current :state] :pending)
     :fx [[:http {:method :get
                  :uri (url-tpl/render campaigns-url
                                       (merge url-context {:advertiser-id (:advertiser-id context)
                                                           :config-id adserver-config-id})
                                       {:search search})
                  :headers {"Authorization" (:resource.user/token cofx)}
                  :on-success [:resource.adform-campaigns/success]
                  :on-failure [:resource.adform-campaigns/failure]}]]}))

(rf/reg-event-db :resource.adform-campaigns/success
  (fn [db [_ campaigns]]
    (assoc db :resource.adform-campaigns/current {:state :success
                                                  :value campaigns})))

(rf/reg-event-db :resource.adform-campaigns/failure
  (fn [db [_ _error]]
    (assoc db :resource.adform-campaigns/current {:state :failure
                                                  :value nil})))

(rf/reg-sub :resource.adform-campaigns/current
  (fn [db]
    (:resource.adform-campaigns/current db)))
